import { text } from "./text"
import { lineLink } from "./App"
import FacebookIcon from "@mui/icons-material/Facebook"
import LocalPhoneIcon from "@mui/icons-material/LocalPhone"
export function contact() {
  return (
    <div className="text-olive bg-secondary p-5">
      <div className="text-3xl text-center p-8 pb-12">
        {text({ en: "Contact", th: "ติดต่อ" })}
      </div>
      <div className="grid lg:grid-cols-3 grid-cols-1 gap-4 items-center ">
        <div className="mx-auto h-full w-full text-center ">
          <div className="text-xl text-muted p-4">
            <a href="tel:0615498229" aria-label="Call Nan Lamoon Hotel">
              {" "}
              <LocalPhoneIcon style={{ fontSize: "800%" }} />
            </a>
          </div>
          <div className="text-xl text-muted p-4">
            <a href="tel:0615498229">061-549-8229</a>
          </div>
        </div>

        <div className="mx-auto text-center h-full w-full  ">
          <div className="text-xl text-muted p-4">
            <a href={lineLink} target="_blank" rel="noopener noreferrer">
              <img
                className=" mx-auto rounded-2xl w-1/3 text-xl p-4 "
                src="line.png"
                alt="LINE"
              />
            </a>
          </div>
          <div className="text-xl text-muted p-4">
            <a href={lineLink} target="_blank" rel="noopener noreferrer">
              @NAN0615498229
            </a>
          </div>
        </div>

        <div className="mx-auto  h-full  w-full text-center ">
          <div className="text-xl text-muted p-4">
            <a href="https://www.facebook.com/nanlamoonhotel2023" aria-label="Nan Lamoon Hotel on Facebook">
              <FacebookIcon style={{ fontSize: "800%" }} />
            </a>
          </div>
          <div className="text-xl text-muted p-4">
            <a href="https://www.facebook.com/nanlamoonhotel2023">
              Nan Lamoon Hotel
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
